import axios from "axios";
import { NGROK } from "../../../../APIs";

export interface SelectableItemsResponse {
  users?: string[];
  serviceAccounts?: string[];
  serviceAccount?: string[];
  awsIamRole?: string[];
  resources?: Record<string, string[]>;
}

export const fetchSelectableUsers = async (
  tenantName: string,
  cloudId: string,
  cloudType: string,
): Promise<string[]> => {
  if (!tenantName || !cloudId || !cloudType) return [];
  const { data } = await axios.get<SelectableItemsResponse>(
    `${NGROK}/api/cloud/get-alert-selectable-items`,
    {
      params: { tenantName, cloudId, cloudType: cloudType.toUpperCase() },
    },
  );
  return Array.isArray(data?.users) ? data.users : [];
};

export interface NhiIdentifier {
  tenantName: string;
  cloudId: string;
  entityId: string;
}

const buildOwnerParams = (cloudProvider: string, identifier: NhiIdentifier) => {
  const cp = cloudProvider.toLowerCase();
  if (cp === "gcp") {
    return { tenantName: identifier.tenantName, projectId: identifier.cloudId, serviceAccountEmail: identifier.entityId };
  }
  if (cp === "aws") {
    return { tenantName: identifier.tenantName, accountId: identifier.cloudId, roleArn: identifier.entityId };
  }
  return { tenantName: identifier.tenantName, subscriptionId: identifier.cloudId, instanceId: identifier.entityId };
};

export const updateNhiOwners = async (
  cloudProvider: string,
  identifier: NhiIdentifier,
  owners: string[],
): Promise<boolean> => {
  const cp = cloudProvider.toLowerCase();
  const { data } = await axios.post<boolean>(
    `${NGROK}/api/nhi-governance/${cp}/owners`,
    owners,
    { params: buildOwnerParams(cloudProvider, identifier) },
  );
  return Boolean(data);
};

export const deleteNhi = async (
  cloudProvider: string,
  identifier: NhiIdentifier,
): Promise<boolean> => {
  const cp = cloudProvider.toLowerCase();
  const { data } = await axios.post<boolean>(
    `${NGROK}/api/nhi-governance/${cp}/delete`,
    null,
    { params: buildOwnerParams(cloudProvider, identifier) },
  );
  return Boolean(data);
};
